// removed by extract-text-webpack-plugin
module.exports = {"variables":"'./variables.css'","hobnob-teal":"#80C785","mercury":"#E5E5E5","text-input":"inputs__text-input__YT7SR","transparent-text-input":"inputs__transparent-text-input__9Kb-_ inputs__text-input__YT7SR","submit-button":"inputs__submit-button__32Tcl","transparent-submit-button":"inputs__transparent-submit-button__9xe0U inputs__submit-button__32Tcl"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/inputs.css
// module id = 199
// module chunks = 1